export const TEXT_OPTIONS_HEIGHT = '1000px';
